<template>
    <div class="p-3">
        <h3>Detail Berkas Pasien</h3>
        <hr>

        <router-link class="btn btn-sm btn-danger" :to="`/pasien-tidak-aktif-5-tahun/${Medrec}`">Kembali</router-link>
        <button class="btn btn-sm btn-primary" @click="scanNewDocs">Scan Berkas</button>

        <div class="row mt-3">
            <div class="col-md-6">
                <div class="card">
                    <div class="card-header text-white bg-primary">
                        Daftar Berkas Pasien
                    </div>
                    <div class="card-body">
                        <table class="table mb-3" v-for="(bp, idx) in berkas_pasien" :key="idx">
                            <tbody>
                                <tr>
                                    <td width="5%">{{ idx + 1 }}</td>
                                    <td width="20%">Judul</td>
                                    <td>{{bp.doc_title}}</td>
                                </tr>
                                <tr>
                                    <td width="5%"></td>
                                    <td width="20%">Deskripsi</td>
                                    <td>{{bp.doc_description}}</td>
                                </tr>
                                <tr>
                                    <td width="5%"></td>
                                    <td width="20%">Dibuat Oleh</td>
                                    <td>{{bp.created_by}}</td>
                                </tr>
                                <tr>
                                    <td width="5%"></td>
                                    <td width="20%">Tanggal</td>
                                    <td>{{bp.created_at}}</td>
                                </tr>
                                <tr>
                                    <td width="5%"></td>
                                    <td width="20%">Dokumen Pasien</td>
                                    <td><button @click="previewBerkas(bp)" class="btn btn-sm btn-primary">Lihat</button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="row" v-if="scan_new">
                    <div class="col">
                        <div class="card">
                            <div class="card-header text-white bg-primary">
                                Scan Berkas Baru
                            </div>
                            <div class="card-body">
                                <div class="row mb-1">
                                    <label for="judul-berkas" class="col-md-4">Judul</label>
                                    <div class="col-sm-8">
                                        <input type="text" v-model="scan_baru.judul_berkas" id="judul-berkas" class="form-control">
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label for="tanggal-berkas" class="col-md-4">Tanggal</label>
                                    <div class="col-sm-8">
                                        <input type="date" v-model="scan_baru.tanggal_berkas" id="tanggal-berkas" class="form-control">
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label for="deskripsi" class="col-md-4">Deskripsi</label>
                                    <div class="col-sm-8">
                                        <textarea v-model="scan_baru.deskripsi" id="scan_baru.deskripsi" class="form-control"></textarea>
                                    </div>
                                </div>
                                <div class="row">
                                    <label for="list-image" class="col-md-4">Daftar Dokumen</label>
                                    <div class="col-md-8">
                                        <ul v-if="scan_baru.doc_lists.length > 0">
                                            <li v-for="(dl, idx) in scan_baru.doc_lists" :key="idx">{{dl.filename}}</li>
                                        </ul>
                                        <p v-if="scan_baru.doc_lists.length == 0">Belum ada dokumen</p>
                                    </div>
                                </div>
                                <div class="row mb">
                                    <div class="col-md-4"></div>
                                    <div class="col-md-8">
                                        <button class="btn btn-sm btn-primary" @click="scanBerkas">Scan</button>
                                        <button class="btn btn-sm btn-success" @click="simpanBerkas">Simpan</button>
                                        <button class="btn btn-sm btn-danger" @click="scan_new = false">Batal</button>
                                    </div>
                                </div>
                                <hr>
                                <div class="row mb-1 mt-3">
                                    <img v-for="(sbdl, idx) in scan_baru.doc_lists" :key="idx" style="width: 100%" v-bind:src="sbdl.preview_url" alt="Preview Image">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="preview_id">
                    <h4>{{ berkas_title }}</h4>
                    <template v-if="berkas_image.length > 0">
                        <img v-for="(b, idx) in berkas_image" :key="idx" style="width: 100%" v-bind:src="`/${b.file_name}`" alt="Preview Image">>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { format } from 'date-fns'

export default {
    data() {
        return {
            Medrec: '',
            berkas_pasien: [],
            preview_id: null,
            berkas_title: null,
            berkas_image: [],
            ws_mdl: null,
            validMimeRegex: /^data:(application\/pdf|image\/.+);base64/,
            wsCTWAIN: null,
            scanCounter: 1,
            pdfPlaceholder: '/images/pdf.png',
            thumbnailId: 0,
            scan_new: false,
            scan_baru: {
                judul_berkas: '',
                tanggal_berkas: format(new Date(), 'yyyy-MM-dd'),
                deskripsi: '',
                doc_lists: []
            },
        }
    },
    created() {
        this.Medrec = this.$route.params.Medrec
        this.getBerkasPasien()
        this.scanWS()
    },
    mounted() {
        document.addEventListener('click', this.handleClickOnDynamicButton)
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOnDynamicButton)
    },
    methods: {
        handleClickOnDynamicButton(ev) {
            console.log('dynamic event', ev.target.id)
        },
        scanNewDocs() {
            this.scan_new = true
            this.preview_id = null
            this.berkas_title = null
            this.berkas_image = []
        },
        getBerkasPasien() {
            const uri = `/api/retensi-dan-pemusnahan/berkas-pasien?medrec=${this.Medrec}`

            this.axios.get(uri).then(response => {
                if (response.data.status == 'success') {
                    this.berkas_pasien = response.data.berkas_pasien
                }
            })
        },
        previewBerkas(berkas) {
            this.scan_baru = {
                judul_berkas: '',
                tanggal_berkas: format(new Date(), 'yyyy-MM-dd'),
                deskripsi: '',
                doc_lists: []
            }
            this.scan_new = false

            this.preview_id = berkas.id
            this.berkas_title = berkas.doc_title
            if (berkas.berkas_rm_files.length > 0) {
                this.berkas_image = berkas.berkas_rm_files
            } else {
                this.berkas_image = null
            }
            console.log('preview_id', this.preview_id)
            console.log('berkas_title', this.berkas_title)
            console.log('berkas_image', this.berkas_image)
        },
        scanWS() {
            this.ws_mdl = new WebSocket('ws://localhost:4649/DirectoryListener')

            this.ws_mdl.addEventListener('message', (ev) => {
                let data = ev.data
                console.log('validmimeregex', this.validMimeRegex)
                if (this.validMimeRegex != undefined) {
                    if (this.validMimeRegex.test(data)) {
                        this.handleDataUrl(data, 'Scanner #' + (this.scanCounter++))
                    } else {
                        console.log(data)
                    }
                }
            })

            this.ws_mdl.addEventListener('error', (ev) => {
                console.log(ev)
                this.ws_mdl.close()
                this.ws_mdl = null
            });

            this.ws_mdl.addEventListener('open', (ev) => {
                this.ws_mdl.send('start')
            });
        },
        scanBerkas() {
			if (null == this.wsCTWAIN) {
				this.wsCTWAIN = new WebSocket('ws://localhost:4649/CmdTwain');
				this.wsCTWAIN.addEventListener('message', (ev) => {
					let data = ev.data
					console.log(data)
				});

				this.wsCTWAIN.addEventListener('error', (ev) => {
					console.log(ev);
					this.wsCTWAIN.close()
					this.wsCTWAIN = null
				})

				this.wsCTWAIN.addEventListener('open', (ev) => {
					this.wsCTWAIN.send('scan')
				});
			} else {
				this.wsCTWAIN.send('scan')
			}
        },
        handleDataUrl(dataUrl, filename) {
            console.log('validmimeregex', this.validMimeRegex)
            if (this.validMimeRegex != undefined) {
                if (!this.validMimeRegex.test(dataUrl)) {
                    console.error('Invalid mime');
                    return false;
                }
    
                let isPdf = /^data:application\/pdf;base64/.test(dataUrl)
                let thumbnail = this.createThumbnail(dataUrl, isPdf, filename)
                // thumbnail.attr('data-id', --this.thumbnailId)
                $('#thumbnails').html(thumbnail)
            }
        },
        createThumbnail(url, isPdf, filename) {
            let previewUrl = isPdf ? this.pdfPlaceholder : url
            this.scan_baru.doc_lists.push({
                filename: filename,
                preview_url: previewUrl,
                doc_type: isPdf ? 'pdf' : 'image',
            })
            // this.saveThumbnail(previewUrl, filename)

            return $(`
                <div class="mb-1">
                    <a href="${url}" target="_blank" class="btn btn-sm btn-success" id="preview">Preview Image</a>&nbsp;
                </div>
                <br>
                <img style="width: 100%" class="${isPdf ? 'pdf' : 'img'}-preview" src="${previewUrl}" alt="Preview Image">
            `)
        },
        saveThumbnail(thumbnail, filename) {
            const uri = `/api/retensi-dan-pemusnahan/simpan-berkas-image`

            const data_post = {
                nomor_rm: this.Medrec,
                tanggal: this.scan_baru.tanggal_berkas,
                image: thumbnail,
                filename: filename
            }

            this.axios.post(uri, data_post).then(response => {
                if (response.data.status =='success') {
                    this.scan_baru.doc_lists.push(response.data.berkas_image)
                    console.log('berkas_image', this.scan_baru.doc_lists)
                }
            })
        },
        simpanBerkas() {
            const uri = `/api/retensi-dan-pemusnahan/simpan-berkas-pasien`

            const data_post = {
                medrec: this.Medrec,
                data_scan: this.scan_baru
            }

            this.axios.post(uri, data_post).then(response => {
                if (response.data.status =='success') {
                    this.getBerkasPasien()
                }
            })
        }
    }
}
</script>